import { action, observable, isObservableProp, extendObservable, computed, reaction, toJS } from 'mobx';

const isBrowser = typeof window !== 'undefined';

/**
 * Локальное хранилище localStorage браузера
 */
export default class LocalStore {

	// Интервал синхронизации хранилища, если указан
	// по умолчанию отключено
	// ВНИМАНИЕ! При хот релоаде начинают плодится эти вызовы, так как фактически
	// состояние приложения не чистится, требуется F5
	// В рабочем окружении все нормально.
	_timeout = 0;

	// Собственные ключи класса
	_ownKeys = [];

	// Префикс ключей в localStorage, для избежания конфликтов с другими хранилищами
	// что позволит иметь несколько локальных хранилишь в приложении
	_prefix = 'smartplatform';

	_disposers = [];
	
	_subscribers = [];

	// Состояние ошибок работы хранилища
	@observable error;

	constructor ({timeout, prefix} = {}) {
		// сохраняем все ключи класса, для определения какие ключи не
		// принадлежат классу LocalStore
		this._ownKeys = [...Object.keys (this), ...Object.keys (LocalStore.prototype)];
		this._timeout = timeout || this._timeout;
		this._prefix = prefix || this._prefix;

		this.load ();
		this._timeout && setTimeout (this.save, this._timeout);
	}

	@action extend = (object) => {
		let keys = Object.keys (object);

		keys.forEach (key => this._initKey (key, this [key] === undefined ? object [key] : this [key]));
		keys.forEach (this._saveKey);

		// this.save ();
	};

	@action save = () => {
		// все ключи кроме собственных
		let keys = Object.keys (this).filter (key => this._ownKeys.indexOf (key) === -1, this);
		// все ключи которые еще не observable
		let newKeys = keys.filter (key => !isObservableProp (this, key));

		// формирование новыйх observable ключей в классе LocalStore
		// если они появились
		newKeys.forEach (key => this._initKey (key));

		// сохраняем состояние в localStorage
		keys.forEach (this._saveKey);

		this._timeout && setTimeout (this.save, this._timeout);
	};

	@action _initKey = (key, value) => {
		// если такой ключ уже есть и он observable
		if (isObservableProp (this, key)) {
			return;
		}

		this._disposers [key] && this._disposers [key] ();
		// сохраняем старое значение ключа
		value = (value === undefined) ? this [key] : value;

		// удаляем новый ключ, в противном случае observable () не сможет отработать
		delete this [key];

		// создаем новый observable ключ в LocalStore
		// TODO: использовать decorate
		extendObservable(this, { [key]: value });

		this._disposers [key] = reaction (
			() => ({
				key, // то что нам нужно во второй функции
				value: JSON.stringify(this[key]) // в возвращающемся выражении обязательно должен быть observable
			}),
			({ key }) => this._saveKey (key));
	};

	_saveKey = (key) => {
		if (!isBrowser) return;
		// console.log ('LocalStore._saveKey', key);
		try {
			const fullKey = `${this._prefix}:${key}`;
			const value = this [key];
			if (value === undefined) {
				localStorage.removeItem (fullKey);
			} else {
				localStorage.setItem (fullKey, JSON.stringify (this [key]));
			}
			this._subscribers.forEach(cb => cb(key));
		} catch (error) {
			this.error = error;
		}
	};

	@action load = () => {
		if (!isBrowser) return;
		for (let i = 0; i < localStorage.length; i ++) {
			let fullKey = localStorage.key (i);
			let key = fullKey.split (`${this._prefix}:`) [1];

			if (key) {
				let item = localStorage.getItem (fullKey);
				try {
					let value = item ? JSON.parse (item) : undefined;
					this._initKey (key, value);
				}
				catch (error) {}
			}
		}
	};
	
	subscribe = cb => this._subscribers.push(cb);

	unsubscribe = cb => {
		const index = this._subscribers.findIndex(_cb => _cb === cb);
		if (index !== -1) this._subscribers.splice(index, 1);
	}
	
};
